export const DEFAULT_PERMISSION_TIMEOUT_SECONDS = 55;
